import { Component, OnInit } from '@angular/core';
import { InternetProduct, isOptionActive } from '@dch/products-business-logic';
import { Store } from '@ngrx/store';
import {
  ApplicationState,
  getInternetSettingsModemSafety,
  getSelectedProductDetails,
} from '../../../../store/reducers';
import { GetModemSafetySettings } from '../../../../store/actions/internet-settings.actions';
import { OnDestroyHookDirective } from '../../../../shared/hooks';
import { TranslationService } from '@proximus/ng-common';

@Component({
  selector: 'mprd-internet-settings',
  templateUrl: './internet-settings.component.html',
})
export class InternetSettingsComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  internetProductDetails: InternetProduct;

  technicalProfile: string;
  cgnFlag: boolean;
  showHgw4: boolean;
  fixedIpActive: boolean;
  isFixedIpEnabled: boolean;

  constructor(
    private store: Store<ApplicationState>,
    protected translationService: TranslationService,
  ) {
    super();
  }

  ngOnInit() {
    this.store.select(getSelectedProductDetails).subscribe((productDetails) => {
      if (productDetails && productDetails.internetProductDetails) {
        this.internetProductDetails = productDetails.internetProductDetails;
        this.getModemSafety();
        this.showHgw4 =
          this.internetProductDetails?.box?.parentProductMpcUuid === 'DXRJR' ||
          this.internetProductDetails?.showHomeGatewaySection;
        const internetOptions = this.internetProductDetails.options;
        internetOptions.forEach((option) => {
          if (
            option.optionCodeForDescription === 'CFEYV' &&
            isOptionActive(option)
          ) {
            this.fixedIpActive = true;
          }
        });
      }
    });
    this.isFixedIpEnabled =
      this.translationService.getTranslatedValueFor(
        'internet.settings.fix.ip.mac.address.enabled',
      ) === 'true';
  }

  getModemSafety() {
    this.requestModemSafetySettings();
    this.getModemSafetySettings();
  }

  requestModemSafetySettings() {
    this.store.dispatch(
      new GetModemSafetySettings(this.internetProductDetails.internetLoginId),
    );
  }

  getModemSafetySettings() {
    this.addSubscription(
      this.store.select(getInternetSettingsModemSafety).subscribe((data) => {
        this.technicalProfile = data.profile.technicalProfile;
        this.cgnFlag = data.profile.cgnFlag;
      }),
    );
  }
}
